export const AppBusEventType = {
  App: {
    ShowDownloadModal: '@@app/show-download-modal',
    ShowSupportedGamesModal: '@@app/show-supported-games-modal',
    PlayVideoSlider: '@@app/full-screen-video-slider',
    SearchHeaderResult: '@@app/search-header-result',
    TriggerDownload: '@@app/trigger-download',
    ShowLoginModal: '@@app/show-login-modal',
    ShowUninstallModal: '@@app/show-uninstall-modal',
    RefreshInstalledExtensions: '@@app/refresh-installed-extensions',
    CurrentAppChanged: '@@app/current-app-changed',
  },
};
